import _ from 'underscore'
import PaginatedCollection from './paginated_collection'
import Backbone from '@polleverywhere/backbone'
import Group from './group'

/*
 * This is a collection of shared groups. It uses JsonAPI
 *   to allow sorting, searching, and pagination.
 *
 * @namespace Model
 *
 */
export default class SharedGroups extends PaginatedCollection {
  initialize (options = {}) {
    super.initialize(options)

    this.model = Group
    this.url = '/api/groups/shared'

    // Handle URL params
    this.params = new Backbone.Model({})
  }

  /*
   * Fetch shared groups using params set on JsonAPI
   *   and options / params passed in
   *
   * @param {options} options Options for fetching
   * @param {data} options.data Parameters for fetching
   */
  fetch (options) {
    // Default sorting
    if (options == null) { options = {} }
    if (!options.data) { options.data = {} }

    _.defaults(options.data, {
      search: this.params.get('search'),
      sort: this.params.get('sort')
    })

    return super.fetch(options)
  }
}
